<!--选择国家-->
<template>
  <van-popup v-model:show="showPicker" round position="bottom" teleport="body">
    <van-picker
      :columns="columns"
      @cancel="onCancel"
      @confirm="onConfirm"
      :columns-field-names="customFieldName"
      confirm-button-text="确认"
      cancel-button-text="取消"
    />
  </van-popup>
</template>

<script setup lang="ts">
import { computed, defineEmits, defineModel, defineProps, onMounted, withDefaults } from 'vue';
import { keys } from 'lodash-es';
import { storeToRefs, useTenantStore } from '@star/stores';

type Props = {
  isShow?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  isShow: false,
});

const emit = defineEmits(['checked']);

const { countrys } = storeToRefs(useTenantStore());

const columns = computed(() => {
  return keys(countrys.value).map(key => {
    return {
      id: countrys.value[key],
      key: key,
      name: key + ' ' + countrys.value[key],
    };
  });
});

const showPicker = defineModel<boolean>();
const customFieldName = {
  text: 'name',
  value: 'id',
};

const onConfirm = async obj => {
  emit('checked', obj?.selectedOptions?.[0]);
  onCancel();
};

const onCancel = () => {
  showPicker.value = false;
};

onMounted(() => {
  emit('checked', columns.value?.[0]);
});
</script>

<style lang="less" scoped></style>
